import { FC } from 'react';
import classNames from 'classnames';
import galleryCss from '../../../assets/gallery/gallery.module.scss';
import galleryHeaderCss from '../../../assets/gallery/gallery-header.module.scss';
import { GalleryHeaderClose, GalleryHeaderShare } from '#advertDetail/components';

const GalleryHeader: FC = () => (
  <div className={classNames(galleryCss.gallery__header, galleryHeaderCss.galleryHeader)}>
    <GalleryHeaderShare />
    <GalleryHeaderClose />
  </div>
);

export { GalleryHeader };
